/* eslint-disable no-unreachable */
/* eslint-disable no-plusplus */
import { useState, useRef, useEffect, useMemo } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Box, Container, Modal, Button, Typography, CircularProgress, Grid, FormHelperText, Stack } from '@mui/material';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import * as yup from 'yup';
import { ArrowForward, CheckCircle, ControlPoint } from '@mui/icons-material';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import axiosInstance from 'src/utils/axios';
import { useMutationCustom, useQueryCustom } from 'src/utils/reactQueryHooks';
import Page from 'src/components/Page';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useSettings from 'src/hooks/useSettings';
import WaitingBox from 'src/components/WaitingBox/index';
import FormProvider from 'src/components/hook-form/FormProvider';
import api from 'src/services/api';
import persianToEnglishNumber from 'src/utils/persianToEnglishNumber';
import { fDateForApi, toTehranDate } from 'src/utils/formatTime';
import ModalLayout from 'src/components/ModalLayout';
import QuestionComponent from 'src/components/ui/Question/index';
import { useSelector } from 'react-redux';
import { RHFTextField } from 'src/components/hook-form';
import RHFDatePicker from 'src/components/hook-form/RHFDatePicker';
import RHFRadioGroups from 'src/components/hook-form/RHFRadioGroups';
import RHFSelector from 'src/components/hook-form/RHFSelector';
import ProvinceSelector from 'src/components/selector/Province';
import universityCategorySelector from 'src/pages/universityCategory/selector';
import UniversitySelector from 'src/pages/university/selector';
import { CLIENT_TYPE_OP, DUTY_DEFAULT_OP, GENDER_DEFAULT_OP, PASSPORT_DEFAULT_OP, TASHAROF_DEFAULT_OP, TASHAROF_DEFAULT_OP_OTHEER } from 'src/config';
import FormSchema, { FormStep2Schema, OtherFormSchema } from './validation';
import HamrahSection from './component/hamrah';
import axiosInstanceV2 from 'src/utils/axiosV2';
import Iconify from 'src/components/Iconify';
import RemoveNullObjectValue from 'src/utils/RemoveNullObjectValue';
import { PATH_DASHBOARD } from '../../../../../../routes/paths';
import { travelTypeObject } from 'src/enumeration';
import DispatchDateSelector from 'src/components/dispatchDate/selector';
import buildAccess from 'src/permission/buildAccess';
import EProfile from 'src/pages/profiles/enum';
import { hasAccess } from 'src/permission/utiles';

const FirstRegistryForm = ({ travelId = -1, travelType = "" }) => {

    const access = buildAccess(EProfile.routes.name);

    const ModalLayoutQuestionInputRef = useRef();
    const ModalLayoutSuccessRef = useRef();

    const admin = useSelector((store) => store.admin.data);

    const [SearchParams] = useSearchParams();
    const [DisabledHasHamrah, setDisabledHasHamrah] = useState(false)
    const navigate = useNavigate();

    const defaultValues = useMemo(
        () => ({
            id: -1,
            name: '',
            last_name: "",
            shenasname: "",
            codeMeli: "",
            father_name: "",
            birthDate: "",
            gender: "",
            email: "",
            phone: "",
            student_number: "",
            type_of_employment_number: "",
            marride_status: null,
            // type: null,
            tashrof_be_sorat: null,
            gozarnameh_status: null,
            duty_system: null,
            mazhab: null,
            need_vam: null,
            sabegh_tasharof: null,
            home_phone: "",
            has_hamrah: null,
            hamrah_count: null,
            marrid_date: "",
            student_marriage: null,
            provoince_university: null,
            type_university: null,
            university_code: null,
            kunkor: null,
            degree: null,
            // educational_qualification: null,
            type_of_employment: null,
            type_of_employment_state: null,

            companions: [],

            // Step 2
            dispatch_date_1: null,
            dispatch_date_2: null,
        }),

        []
    );


    const handleQuestionModal = (params) => ModalLayoutQuestionInputRef.current.show((p) => !p, params);
    const handleSuccessModal = (params) => ModalLayoutSuccessRef.current?.show((p) => !p, params);

    const queryParams = useParams();
    const { id, travel } = queryParams;
    const { themeStretch } = useSettings();
    const { t } = useTranslation();
    const isAttabat = useMemo(() =>
        [travelTypeObject.atabat_aliat.value].includes(travelType)
        , [travelType])
    const isOtherAttabat = useMemo(() =>
        [travelTypeObject.other.value].includes(travelType)
        , [travelType])
    const [validationState, setValidationState] = useState({});
    const [TravelApi, setTravelApi] = useState();
    const [inputsById, setInputsById] = useState();
    const [beforeRegistrant, setBeforeRegistrant] = useState();
    const [successBeforeRegistrant, setSuccessBeforeRegistrant] = useState();
    const [caravanOptions, setCaravanOptions] = useState();

    const [HideForWemen, setHideForWemen] = useState(false)

    const [companionSectionId, setCompanionSectionId] = useState();

    const [HamrahDataArr, setHamrahDataArr] = useState([]);

    const [TasharofOptionArr, setTasharofOptionArr] = useState((isOtherAttabat || isAttabat) ? TASHAROF_DEFAULT_OP_OTHEER : TASHAROF_DEFAULT_OP)

    const [FormStep, setFormStep] = useState(1)

    const resolverSchema = useMemo(() =>
        yupResolver(FormStep === 1 ? (isOtherAttabat ? OtherFormSchema : FormSchema) : FormStep2Schema),
        [FormStep, isOtherAttabat]);

    const methods = useForm({
        // resolver: yupResolver(FormSchema),
        resolver: resolverSchema,
        // mode: 'onChange',
        mode: 'all',
        shouldUnregister: false,
        defaultValues: defaultValues
    });

    const {
        reset,
        watch,
        control,
        setValue,
        setError,
        handleSubmit,
        getValues,
        formState: { errors, isSubmitting },
    } = methods;

    // const formValue = watch();

    // const genderWatcher = watch('gender');
    // const mirrageStatusWatcher = watch('marride_status');
    // const tasharofWatcher = watch('tashrof_be_sorat');
    // const hasHamragWatcher = watch('has_hamrah');
    // const hamrahCountWatcher = watch('hamrah_count');
    const genderWatcher = useWatch({ control, name: 'gender' });
    const mirrageStatusWatcher = useWatch({ control, name: 'marride_status' });
    const tasharofWatcher = useWatch({ control, name: 'tashrof_be_sorat' });
    const hasHamragWatcher = useWatch({ control, name: 'has_hamrah' });
    const hamrahCountWatcher = useWatch({ control, name: 'hamrah_count' });
    const companions = useWatch({ control, name: 'companions' });
    // const companions = watch("companions") || [];


    const isError = Object.keys(errors)?.length;

    // console.log({ errors, queryParams })

    // ----------------------
    const creating = (params) => axiosInstanceV2.post(api.public.travelRegister.base, params, { params: { travel_id: travelId } });
    const updating = (params) => axiosInstanceV2.put(`${api.public.travelRegister.base}/1`, params, { params: { travel_id: travelId } });
    const getById = () => axiosInstanceV2.get(`${api.travelRegister.register.base}/${queryParams?.["*"]}`, { params: { travel_id: travelId } });
    const getTravelById = () => axiosInstance.get(`${api.travelRegister.base}/${travel}`);
    // ----------------------

    // submit Mutate

    const onSuccessMutating = () => {
        handleSuccessModal();
    };

    // const handleSuccess = () => {
    //     if (isAuthenticated) resQuery.refetch();
    // };
    // const handleSuccessFinally = () => {
    //     if (!isAuthenticated) navigate(PATH_AUTH.login);
    // };

    // submit Mutate (END)

    const { isLoading, mutate } = useMutationCustom({
        url: beforeRegistrant ? updating : creating,
        name: `${api.public.travelRegister.base}_add_first`,
        // invalidQuery: `${Enum?.api?.base}_get_${id}_${travel}`,
        onSuccess: onSuccessMutating,
        //  onError: onErrorMutating,
    });

    const handleGetUserFormData = (data) => {

        const userFormData = data?.data?.clients?.[0];
        const userFormClientsData = data?.data?.clients;
        const userFormRegisterData = data?.data?.register;

        if (userFormData) {
            const userInputStructure = {
                id: userFormData?.id,
                name: userFormData?.name,
                last_name: userFormData?.last_name,
                shenasname: userFormData?.shenasname_number,
                codeMeli: userFormData?.code_melli,
                father_name: userFormData?.father_name,
                birthDate: userFormData?.birthdate ? toTehranDate(userFormData?.birthdate) : "",
                gender: userFormData?.gender ? { label: userFormData?.gender, value: userFormData?.gender } : "",
                email: userFormData?.email ? userFormData?.email : "",
                phone: userFormData?.phone ? userFormData?.phone : "",
                student_number: userFormData?.student_number ? userFormData?.student_number : "",
                marride_status: userFormData?.marital_status ? { label: userFormData?.marital_status, value: userFormData?.marital_status } : null,
                // type: { label: userFormData?.type, value: userFormData?.type },
                tashrof_be_sorat: userFormData?.tasharof_be_soorat ? { label: userFormData?.tasharof_be_soorat, value: userFormData?.tasharof_be_soorat } : null,
                gozarnameh_status: userFormData?.passport_status ? { label: userFormData?.passport_status, value: userFormData?.passport_status } : null,
                duty_system: userFormData?.nezam_vazife_status ? { label: userFormData?.nezam_vazife_status, value: userFormData?.nezam_vazife_status } : null,
                mazhab: userFormData?.religion ? { label: userFormData?.religion, value: userFormData?.religion } : null,
                need_vam: userFormData?.need_vam ? { label: userFormData?.need_vam, value: userFormData?.need_vam } : null,
                sabegh_tasharof: userFormData?.sabeghe_tasharof ? { label: userFormData?.sabeghe_tasharof, value: userFormData?.sabeghe_tasharof } : null,
                home_phone: userFormData?.home_phone ? userFormData?.home_phone : "",
                has_hamrah: userFormData?.has_hamrah ? { label: userFormData?.has_hamrah, value: userFormData?.has_hamrah } : null,
                hamrah_count: userFormData?.hamrah_count ? { label: userFormData?.hamrah_count, value: userFormData?.hamrah_count } : null,
                marrid_date: userFormData?.marriage_date ? new Date(userFormData?.marriage_date) : "",
                student_marriage: userFormData?.student_marriage ? { label: userFormData?.student_marriage, value: userFormData?.student_marriage } : null,
                provoince_university: userFormData?.university_city ? { label: userFormData?.university_city, value: userFormData?.university_city } : null,
                type_university: userFormData?.university_category ? { label: userFormData?.university_category, value: userFormData?.university_category } : null,
                university_code: userFormData?.university_name ? { label: userFormData?.university_name, value: userFormData?.university_name } : null,
                kunkor: userFormData?.konkoor ? { label: userFormData?.konkoor, value: userFormData?.konkoor } : null,
                degree: userFormData?.education_level ? { label: userFormData?.education_level, value: userFormData?.education_level } : null,
                // educational_qualification: null,
                type_of_employment: userFormData?.hokm_kargozini ? { label: userFormData?.hokm_kargozini, value: userFormData?.hokm_kargozini } : null,
                type_of_employment_state: userFormData?.university_level ? { label: userFormData?.university_level, value: userFormData?.university_level } : null,
                type_of_employment_number: userFormData?.hokm_kargozini_number ? userFormData?.hokm_kargozini_number : "",
                companions: [],

                dispatch_date_1: userFormRegisterData?.dispatch1 ? DispatchDateSelector.convertor.object(userFormRegisterData?.dispatch1) : null,
                dispatch_date_2: userFormRegisterData?.dispatch2 ? DispatchDateSelector.convertor.object(userFormRegisterData?.dispatch2) : null,
            }

            if (parseInt(userFormData?.hamrah_count, 10) > 0) {
                userInputStructure.companions = [];
                for (let i = 1; i < userFormClientsData.length; i++) {
                    const element = userFormClientsData[i];
                    const currentCompanionData = {
                        id: element?.id,
                        name: element?.name,
                        last_name: element?.last_name,
                        shenasname_number: element?.shenasname_number,
                        code_meli: element?.code_melli,
                        father_name: element?.father_name,
                        birthDate: new Date(element?.birthdate),
                        gender: { label: element?.gender, value: element?.gender },
                        student_number: element?.student_number ? element?.student_number : "",
                        email: element?.email,
                        phone: element?.phone,
                        marride_status: element?.marital_status ? { label: element?.marital_status, value: element?.marital_status } : null,
                        tashrof_be_sorat: { label: element?.tasharof_be_soorat, value: element?.tasharof_be_soorat },
                        gozarnameh_status: { label: element?.passport_status, value: element?.passport_status },
                        duty_system: { label: element?.nezam_vazife_status, value: element?.nezam_vazife_status },
                        mazhab: element?.religion ? { label: element?.religion, value: element?.religion } : null,
                        need_vam: { label: element?.need_vam, value: element?.need_vam },
                        sabegh_tasharof: { label: element?.sabeghe_tasharof, value: element?.sabeghe_tasharof },
                        home_phone: element?.home_phone,
                        student_marriage: element?.student_marriage ? { label: element?.student_marriage, value: element?.student_marriage } : null,
                        provoince_university: { label: element?.university_city, value: element?.university_city },
                        type_university: { label: element?.university_category, value: element?.university_category },
                        university_code: { label: element?.university_name, value: element?.university_name },
                        kunkor: { label: element?.konkoor, value: element?.konkoor },
                        degree: { label: element?.education_level, value: element?.education_level },
                        is_Student: { label: element?.is_student, value: element?.is_student },
                        // educational_qualification: null,
                        type_of_employment: element?.hokm_kargozini ? { label: element?.hokm_kargozini, value: element?.hokm_kargozini } : null,
                        type_of_employment_state: element?.university_level ? { label: element?.university_level, value: element?.university_level } : null,
                    }
                    userInputStructure.companions.push(currentCompanionData)
                }
            }

            setBeforeRegistrant(true)
            reset(userInputStructure)
        }

    }
    // const getTravelData = useQueryCustom({
    //     url: getTravelById,
    //     name: `${api.public.travelRegister.base}_getById_travel`,
    //     params: { id: travel },
    //     // invalidQuery: `${Enum?.api?.base}_get_${id}_${travel}`,
    // });
    const firstFormOfTravel = useQueryCustom({
        url: getById,
        name: `${api.public.travelRegister.base}_getById_first`,
        params: { id: travel },
        // invalidQuery: `${Enum?.api?.base}_get_${id}_${travel}`,
        onSuccess: handleGetUserFormData,
        // enabled: !!admin?.id
        //  onError: onErrorMutating,
    });


    const onSubmit = async () => {

        const formValue = getValues();

        handleQuestionModal();

        console.log({
            formValue,
            // reqData
        })

        const reqData = {
            travel_id: travelId,
            client_id: id,
            name: formValue.name,
            last_name: formValue.last_name,
            student_number: (formValue.tashrof_be_sorat?.value !== "استاد دانشگاه" && formValue.tashrof_be_sorat?.value !== "کارمند") ? persianToEnglishNumber(formValue.student_number) : undefined,
            code_melli: persianToEnglishNumber(formValue.codeMeli),
            phone: persianToEnglishNumber(formValue.phone),
            shenasname_number: persianToEnglishNumber(formValue.shenasname),
            father_name: formValue.father_name,
            birthdate: persianToEnglishNumber(fDateForApi(formValue.birthDate)),
            gender: formValue.gender?.value,
            email: formValue.email !== "" ? formValue.email : undefined,
            marital_status: formValue.marride_status?.value,
            // type: formValue.type?.value,
            tasharof_be_soorat: formValue.tashrof_be_sorat?.value,
            religion: formValue.mazhab?.value,
            home_phone: persianToEnglishNumber(formValue.home_phone),
            passport_status: formValue.gozarnameh_status?.value,
            nezam_vazife_status: formValue?.gender?.value === "مذکر" ? formValue.duty_system?.value : undefined,
            need_vam: formValue.need_vam?.value,
            sabeghe_tasharof: formValue.sabegh_tasharof?.value,
            marriage_date: (formValue.tashrof_be_sorat?.value === "دانشجویان متاهل" && formValue.marride_status?.value === "متاهل") ? persianToEnglishNumber(fDateForApi(formValue.marrid_date)) : undefined,
            student_marriage: (formValue.tashrof_be_sorat?.value === "دانشجویان متاهل" && formValue.marride_status?.value === "متاهل") ? formValue.student_marriage?.value : undefined,
            has_hamrah: formValue.has_hamrah?.value || "خیر",
            hamrah_count: (formValue.hamrah_count?.value && formValue.has_hamrah?.value === "بله") ? persianToEnglishNumber(formValue.hamrah_count?.value) : 0,
            nesbat_to_head: "سرگروه",
            university_city: formValue.provoince_university?.label,
            university_category: formValue.type_university?.label,
            university_name: formValue.university_code?.label,
            konkoor: formValue.kunkor?.value,
            education_level: formValue?.degree?.value,
            is_student: (formValue.tashrof_be_sorat?.value === "استاد دانشگاه" || formValue.tashrof_be_sorat?.value === "کارمند") ? "خیر" : "بله",
            hokm_kargozini: formValue.tashrof_be_sorat?.value === "استاد دانشگاه" ? formValue?.type_of_employment?.value : undefined,
            university_level: formValue.tashrof_be_sorat?.value === "استاد دانشگاه" ? formValue?.type_of_employment_state?.value : undefined,
            hokm_kargozini_number: formValue.tashrof_be_sorat?.value === "استاد دانشگاه" ? persianToEnglishNumber(formValue.type_of_employment_number) : undefined,

            dispatch_id_1: formValue.dispatch_date_1?.value,
            dispatch_id_2: formValue.dispatch_date_2?.value,
        }

        // reqData = RemoveNullObjectValue(reqData);


        if (
            parseInt(formValue.hamrah_count?.value, 10) > 0 &&
            formValue.has_hamrah.value === "بله" &&
            formValue.tashrof_be_sorat.value?.search("مجرد") === -1
        ) {
            reqData.array = [];

            for (let i = 0; i < parseInt(formValue.hamrah_count?.value, 10); i++) {
                const element = {
                    'name': formValue?.companions[i]?.name,
                    'last_name': formValue?.companions[i]?.last_name,
                    'code_melli': persianToEnglishNumber(formValue?.companions[i]?.code_meli),
                    'phone': persianToEnglishNumber(formValue?.companions[i]?.phone),
                    'shenasname_number': persianToEnglishNumber(formValue?.companions[i]?.shenasname_number),
                    'marital_status': formValue?.companions[i]?.marride_status?.value,
                    'religion': formValue?.companions[i]?.mazhab?.value,
                    'father_name': formValue?.companions[i]?.father_name,
                    'birthdate': persianToEnglishNumber(fDateForApi(formValue?.companions[i]?.birthDate)),
                    'gender': formValue?.companions[i]?.gender?.value,
                    'passport_status': formValue?.companions[i]?.gozarnameh_status?.value,
                    'nezam_vazife_status': formValue?.companions[i]?.gender?.value === "مذکر" ? formValue?.companions[i]?.duty_system?.value : undefined,
                    'need_vam': i == 0 ? formValue?.companions[i]?.need_vam?.value : "نیستم",
                    'nesbat_to_head': i === 0 ? "همسر" : "فرزند",
                    'university_city': formValue?.companions[i]?.is_Student?.value === "بله" ? formValue?.companions[i]?.provoince_university?.label : undefined,
                    'university_category': formValue?.companions[i]?.is_Student?.value === "بله" ? formValue?.companions[i]?.type_university?.label : undefined,
                    'university_name': formValue?.companions[i]?.is_Student?.value === "بله" ? formValue?.companions[i]?.university_code?.label : undefined,
                    'konkoor': formValue?.companions[i]?.kunkor?.value,
                    'education_level': formValue?.companions[i]?.is_Student?.value === "بله" ? formValue?.companions[i]?.degree?.value : undefined,
                    "student_number": formValue?.companions[i]?.is_Student?.value === "بله" ? persianToEnglishNumber(formValue?.companions[i]?.student_number) : undefined,
                    'is_student': formValue?.companions[i]?.is_Student?.value,
                }

                reqData.array.push(RemoveNullObjectValue(element));

            }
        }



        mutate(reqData);

    }

    const handleGoToNextStep = () => {
        setFormStep(old => old + 1)
    }

    const handleGoToPrevStep = () => {
        setFormStep(old => old - 1)
    }



    const handleFilterTasharofBeSorate = () => {

        let helpOptions = (isOtherAttabat || isAttabat) ? TASHAROF_DEFAULT_OP_OTHEER : TASHAROF_DEFAULT_OP;

        if (genderWatcher?.value && genderWatcher?.value === "مذکر") {
            helpOptions = helpOptions.filter(item => item?.value?.search("دختر") === -1)
        } else if (genderWatcher?.value && genderWatcher?.value === "مونث") {
            helpOptions = helpOptions.filter(item => item?.value?.search("پسر") === -1)
        }

        // console.log({ asdasda: mirrageStatusWatcher })
        if (mirrageStatusWatcher?.value && mirrageStatusWatcher?.value === "مجرد") {
            helpOptions = helpOptions.filter(item => item?.value?.search("متاهل") === -1)
        }

        if (helpOptions?.findIndex(item => item?.value === tasharofWatcher?.value) === -1) {
            setValue("tashrof_be_sorat", null)
        }

        if (tasharofWatcher?.value?.search("مجرد") > -1 || (mirrageStatusWatcher?.value && mirrageStatusWatcher?.value === "مجرد")) {
            setValue("hamrah_count", null);
            setValue("has_hamrah", null);
            setValue("companions", []);

        }

        if (mirrageStatusWatcher?.value === "متاهل" && tasharofWatcher?.value === "دانشجویان متاهل") {
            // setValue("hamrah_count", { label: "1", value: "1" });
            if (getValues("hamrah_count")?.value) {
                if (parseInt(getValues("hamrah_count")?.value, 10) < 1) {
                    setValue("hamrah_count", { label: "1", value: "1" });
                }
            } else {
                setValue("hamrah_count", { label: "1", value: "1" });
            }
            setValue("has_hamrah", { label: "بله", value: "بله" });
            setDisabledHasHamrah(true)
        } else {
            setDisabledHasHamrah(false)
        }

        setTasharofOptionArr(helpOptions)
    }


    useEffect(() => {
        handleFilterTasharofBeSorate()
    }, [genderWatcher, mirrageStatusWatcher, tasharofWatcher])

    useEffect(() => {
        if (hasHamragWatcher?.value !== "بله") {
            setValue("hamrah_count", null);
            setValue("companions", []);
        }
    }, [hasHamragWatcher])


    // Watch `hamrah_count` and adjust `companions` array accordingly
    useEffect(() => {
        const count = hamrahCountWatcher?.value || 0;

        if (companions.length < count) {
            // Add companions to match the count
            setValue("companions", [...companions, ...Array(count - companions.length).fill({
                need_vam: count > 1 ? { label: "نیستم", value: "نیستم" } : null
            })]);
        } else if (companions.length > count || tasharofWatcher?.value?.search("مجرد") > -1) {
            // Remove excess companions
            setValue("companions", companions.slice(0, count));
        }
    }, [hamrahCountWatcher]);



    return (
        <>
            {firstFormOfTravel?.isLoading ? <WaitingBox /> :
                <>
                    <Page
                        sx={{
                            py: 3,
                        }}
                        title={"ثبت نام اولیه"}
                    >

                        <ModalLayout ref={ModalLayoutQuestionInputRef}>
                            <QuestionComponent
                                {...{
                                    title: beforeRegistrant ? 'آیا از تغییر اطلاعات مطمئن هستید؟' : 'آیا از تایید ثبت نام مطمئن هستید؟',
                                    description: beforeRegistrant
                                        ? 'پس از تایید اطلاعات جدید در لیست زائرین قرار خواهد گرفت . آیا ادامه میدهید؟'
                                        : 'پس از تایید اطلاعات ، در لیست زائرین قرار خواهد گرفت . آیا ادامه میدهید؟',
                                    button: {
                                        confirm: {
                                            label: 'question.yesProcess',
                                            loading: isLoading,
                                            onClick: (_, data) => onSubmit(data),
                                        },
                                        reject: {
                                            label: 'question.no',
                                            onClick: () => handleQuestionModal(),
                                        },
                                    },
                                }}
                            // onClose={() => handleQuestionModal()}
                            />
                        </ModalLayout>

                        <ModalLayout ref={ModalLayoutSuccessRef} onClosed={() => null}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    border: '1px solid #ccc',
                                    borderRadius: 1,
                                    backgroundColor: 'common.white',
                                }}
                            >
                                {/* <Box sx={{
                                    "svg":{
                                        width:"80px",
                                        height:"80px",
                                        color:"success.main"
                                    }
                                }}>
                                    <CheckCircle />
                                </Box> */}
                                <Box
                                    sx={{
                                        mt: '-20px',
                                        svg: {
                                            width: '65px',
                                            height: '65px',
                                            color: 'success.main',
                                            backgroundColor: 'common.white',
                                            borderRadius: '100%',
                                        },
                                    }}
                                >
                                    <CheckCircle />
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        p: 3,
                                        gap: 2,
                                        position: 'relative',
                                    }}
                                >
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            color: 'success.main',
                                        }}
                                    >
                                        {beforeRegistrant
                                            ? 'تغییر اطلاعات با موفقیت انجام شد.'
                                            : 'ثبت نام با موفقیت انجام شد.'}
                                    </Typography>

                                    {/* {true ? <Typography variant="h6">{'منتظر قرعه کشی باشید.'}</Typography> : ''} */}

                                    <Button
                                        color="success"
                                        variant="contained"
                                        onClick={() => {
                                            handleSuccessModal();
                                            navigate(PATH_DASHBOARD.visitorManagement.root(travelType, SearchParams.get("travel")) + "/registrations")
                                            // completed?.();
                                            // refetch?.();
                                        }}
                                    >
                                        {'بستن'}
                                    </Button>
                                </Box>
                            </Box>
                        </ModalLayout>

                        <FormProvider methods={methods} onSubmit={handleSubmit((isAttabat && FormStep === 1) ? handleGoToNextStep : handleQuestionModal)}>
                            {FormStep === 1 && (
                                <>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 4,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                p: 2,
                                                backgroundColor: 'grey.main',
                                                borderRadius: '8px',
                                            }}
                                        >
                                            <Typography>اطلاعات فردی</Typography>

                                        </Box>
                                        <Grid sx={{}} container spacing={3}>
                                            <Grid item xs={12} md={6}>
                                                <RHFTextField
                                                    name={"name"}
                                                    label={"نام"}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFTextField
                                                    name={"last_name"}
                                                    label={"نام خانوادگی"}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFTextField
                                                    name={"shenasname"}
                                                    label={"شماره شناسنامه"}
                                                    type={"numbers"}
                                                    disableComma
                                                    withZero
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFTextField
                                                    name={"codeMeli"}
                                                    label={"کدملی"}
                                                    type={"numbers"}
                                                    disableComma
                                                    withZero
                                                    required
                                                    disabled={admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFTextField
                                                    name={"father_name"}
                                                    label={"نام پدر"}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFDatePicker
                                                    name={"birthDate"}
                                                    label={"تاریخ تولد"}
                                                    pickerProps={{
                                                        maxDate: new Date(),
                                                    }}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFRadioGroups
                                                    options={GENDER_DEFAULT_OP}
                                                    name={"gender"}
                                                    label={"جنسیت"}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFTextField
                                                    name={"email"}
                                                    label={"پست الکترونیک"}
                                                // required
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFTextField
                                                    name={"phone"}
                                                    label={"تلفن همراه"}
                                                    required
                                                // disabled={!!admin?.id}
                                                />
                                                <Stack direction={"row"} gap={1} alignItems={"center"} sx={{ mt: 1 }}>
                                                    <Iconify icon={"fluent:info-12-regular"} sx={{ fontSize: 20, color: "#707070" }} />
                                                    <Typography sx={{ fontSize: 13, color: "#707070" }}>تلفن همراه باید به نام فرد باشد</Typography>
                                                </Stack>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFSelector
                                                    options={
                                                        [
                                                            { label: "مجرد", value: "مجرد" },
                                                            (!isOtherAttabat && ([
                                                                { label: "متاهل", value: "متاهل" },
                                                            ]))
                                                        ].filter(Boolean).flat()
                                                    }
                                                    name={"marride_status"}
                                                    label={"وضعیت تاهل"}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFSelector
                                                    options={TasharofOptionArr}
                                                    name={"tashrof_be_sorat"}
                                                    label={"تشرف به صورت"}
                                                    required
                                                    disabled={admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <RHFSelector
                                                    options={PASSPORT_DEFAULT_OP}
                                                    name={"gozarnameh_status"}
                                                    label={"وضعیت گذرنامه"}
                                                    required
                                                />
                                            </Grid>
                                            {(
                                                (mirrageStatusWatcher?.value && mirrageStatusWatcher?.value === "متاهل") &&
                                                (tasharofWatcher?.value && tasharofWatcher?.value === "دانشجویان متاهل")
                                            ) &&
                                                <>
                                                    <Grid item xs={12} md={6}>
                                                        <RHFDatePicker
                                                            name={"marrid_date"}
                                                            label={"تاریخ عقد"}
                                                            pickerProps={{
                                                                maxDate: new Date(),
                                                            }}
                                                            required
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <RHFSelector
                                                            options={[
                                                                { label: "بله", value: "بله" },
                                                                { label: "خیر", value: "خیر" }
                                                            ]}
                                                            name={"student_marriage"}
                                                            label={"ازدواج دانشجویی"}
                                                            required
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {genderWatcher.value === "مذکر" &&
                                                <>
                                                    <Grid item xs={12} md={6}>
                                                        <RHFSelector
                                                            options={DUTY_DEFAULT_OP}
                                                            name={"duty_system"}
                                                            label={"وضعیت نظام وظیفه"}
                                                            required
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            <Grid item xs={12} md={6}>
                                                <RHFSelector
                                                    options={[
                                                        { label: "تشیع", value: "تشیع" },
                                                        { label: "تسنن", value: "تسنن" }
                                                    ]}
                                                    name={"mazhab"}
                                                    label={"مذهب"}
                                                    required
                                                />
                                            </Grid>
                                            {!isOtherAttabat && (
                                                <Grid item xs={12} md={6}>
                                                    <RHFSelector
                                                        options={[
                                                            { label: "هستم", value: "هستم" },
                                                            { label: "نیستم", value: "نیستم" }
                                                        ]}
                                                        name={"need_vam"}
                                                        label={
                                                            <>
                                                                <Typography component={"span"}>متقاضی دریافت</Typography>
                                                                <Typography component={"span"} sx={{ color: 'red' }}> وام</Typography>
                                                            </>
                                                        }
                                                        required
                                                    />
                                                </Grid>
                                            )}
                                            <Grid item xs={12} md={6}>
                                                <RHFSelector
                                                    options={[
                                                        { label: "اعزام با دانشگاهیان", value: "اعزام با دانشگاهیان" },
                                                        { label: "اعزام غیر دانشگاهی", value: "اعزام غیر دانشگاهی" },
                                                        { label: "نداشته ام", value: "نداشته ام" },
                                                    ]}
                                                    name={"sabegh_tasharof"}
                                                    label={"سابقه تشرف"}
                                                    required
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <RHFTextField
                                                    name={"home_phone"}
                                                    label={"تلفن ثابت (به همراه کد)"}
                                                    required
                                                />
                                            </Grid>

                                            {tasharofWatcher?.value === "استاد دانشگاه" ?
                                                <>
                                                    <Grid item xs={12} md={6}>
                                                        <RHFTextField
                                                            name={"type_of_employment_number"}
                                                            label={"شماره حکم کارگزینی"}
                                                            key={"type_of_employment_number"}
                                                            required
                                                        />
                                                    </Grid>
                                                </>
                                                :
                                                <>
                                                    {tasharofWatcher?.value !== "کارمند" ?

                                                        <Grid item xs={12} md={6}>
                                                            <RHFTextField
                                                                name={"student_number"}
                                                                label={"شماره دانشجویی"}
                                                                key={"student_number"}
                                                                required
                                                            />
                                                        </Grid>
                                                        :
                                                        <></>
                                                    }
                                                </>
                                            }

                                            {/* <Grid item xs={12} md={6}>
                                                <RHFSelector
                                                    options={CLIENT_TYPE_OP}
                                                    name={"type"}
                                                    label={"نوع زائر"}
                                                    required
                                                />
                                            </Grid> */}


                                            {(
                                                !isOtherAttabat &&
                                                (mirrageStatusWatcher?.value && mirrageStatusWatcher?.value === "متاهل") &&
                                                (tasharofWatcher?.value && tasharofWatcher?.value?.search("مجرد") === -1)
                                            ) &&
                                                <>
                                                    <Grid item xs={12} md={6}>
                                                        <RHFSelector
                                                            options={[
                                                                { label: "بله", value: "بله" },
                                                                { label: "خیر", value: "خیر" }
                                                            ]}
                                                            name={"has_hamrah"}
                                                            label={"اعزام با همراه"}
                                                            disabled={DisabledHasHamrah || (admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0)}
                                                            required
                                                        />
                                                        <Stack direction={"row"} gap={1} alignItems={"center"} sx={{ mt: 1 }}>
                                                            <Iconify icon={"fluent:info-12-regular"} sx={{ fontSize: 20, color: "#707070" }} />
                                                            <Typography sx={{ fontSize: 13, color: "#707070" }}>همراه فقط شامل همسر و فرزند می باشد</Typography>
                                                        </Stack>
                                                    </Grid>
                                                    {(hasHamragWatcher?.value === "بله") &&
                                                        <Grid item xs={12} md={6}>
                                                            <RHFSelector
                                                                options={[
                                                                    { label: "1", value: "1" },
                                                                    { label: "2", value: "2" },
                                                                    { label: "3", value: "3" },
                                                                    { label: "4", value: "4" }
                                                                ]}
                                                                name={"hamrah_count"}
                                                                label={"تعداد همراه"}
                                                                disabled={admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0}
                                                                required
                                                            />
                                                        </Grid>
                                                    }
                                                </>
                                            }
                                        </Grid>

                                    </Box>

                                    {(
                                        (mirrageStatusWatcher?.value && mirrageStatusWatcher?.value === "متاهل") &&
                                        tasharofWatcher?.value?.search("مجرد") === -1 &&
                                        parseInt(hamrahCountWatcher?.value, 10) > 0 &&
                                        hasHamragWatcher.value === "بله"
                                    ) &&
                                        <>

                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 4,
                                                    mt: 3
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        p: 2,
                                                        backgroundColor: 'grey.main',
                                                        borderRadius: '8px',
                                                    }}
                                                >
                                                    <Typography>اطلاعات همراهان</Typography>

                                                </Box>
                                                {Array(parseInt(hamrahCountWatcher?.value, 10)).fill("").map((_, index) =>
                                                    <>

                                                        <HamrahSection index={index} key={`hamrah-${index}`} HamrahDataArr={HamrahDataArr} setHamrahDataArr={HamrahDataArr} getValues={getValues} />
                                                    </>
                                                )}


                                            </Box>

                                        </>
                                    }


                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 4,
                                            mt: 4
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                p: 2,
                                                backgroundColor: 'grey.main',
                                                borderRadius: '8px',
                                            }}
                                        >
                                            <Typography>اطلاعات دانشگاهی</Typography>

                                        </Box>
                                        <Grid sx={{}} container spacing={3}>
                                            <Grid item xs={12} md={6}>
                                                <ProvinceSelector.Element
                                                    name={"provoince_university"}
                                                    // label={"استان محل تحصیل"}
                                                    label={(isOtherAttabat ? "استان محل دانشگاه" : (tasharofWatcher?.value === "استاد دانشگاه" ? "استان محل دانشگاه" : "استان محل دانشگاه"))}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <universityCategorySelector.Element
                                                    name={"type_university"}
                                                    label={"نوع دانشگاه"}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <UniversitySelector.Element
                                                    name={"university_code"}
                                                    // provinceId={getValues("provoince_university")?.value || undefined}
                                                    // categoryId={getValues("type_university")?.value || undefined}
                                                    province_name={getValues("provoince_university")?.label || undefined}
                                                    category_name={getValues("type_university")?.label || undefined}
                                                    label={"نام دانشگاه"}
                                                    required
                                                />
                                            </Grid>
                                            {(!isOtherAttabat && tasharofWatcher?.value !== "کارمند") && (
                                                <>
                                                    {/* <Grid item xs={12} md={6}>
                                                        <RHFSelector
                                                            options={[
                                                                { label: "شرکت نکرده ام", value: "شرکت نکرده ام" },
                                                                // { label: "کاردانی", value: "کاردانی" },
                                                                { label: "کارشناسی ارشد ناپیوسته", value: "کارشناسی ارشد ناپیوسته" },
                                                                { label: "دوره دکتری", value: "دوره دکتری" },
                                                                { label: "امتحان جامع علوم پایه پزشکی", value: "امتحان جامع علوم پایه پزشکی" },
                                                                { label: "کاردانی به کارشناسی", value: "کاردانی به کارشناسی" },
                                                            ]}
                                                            name={"kunkor"}
                                                            label={"کنکور (وضعیت شرکت در کنکور های سراسری سال جاری)"}
                                                            required
                                                        />
                                                    </Grid> */}
                                                    <Grid item xs={12} md={6}>
                                                        <RHFSelector
                                                            options={[
                                                                { label: "کاردانی", value: "کاردانی" },
                                                                { label: "کارشناسی", value: "کارشناسی" },
                                                                { label: "کارشناسی ارشد", value: "کارشناسی ارشد" },
                                                                { label: "دکتری", value: "دکتری" },
                                                            ]}
                                                            name={"degree"}
                                                            label={"مقطع تحصیلی"}
                                                            required
                                                        />
                                                    </Grid>
                                                </>
                                            )}
                                            {tasharofWatcher?.value === "استاد دانشگاه" &&
                                                <>
                                                    <Grid item xs={12} md={6}>
                                                        <RHFSelector
                                                            options={[
                                                                { label: "هيئت علمي رسمي تمام وقت", value: "هيئت علمي رسمي تمام وقت" },
                                                                { label: "هيئت علمي نيمه وقت", value: "هيئت علمي نيمه وقت" },
                                                                { label: "حق التدريس", value: "حق التدريس" },
                                                                { label: "پيماني", value: "پيماني" },
                                                                { label: "رسمي-آزمايشي", value: "رسمي-آزمايشي" },
                                                                { label: "ساير احکام", value: "ساير احکام" },
                                                            ]}
                                                            name={"type_of_employment"}
                                                            label={"نوع حکم کارگزینی"}
                                                            required
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <RHFSelector
                                                            options={[
                                                                { label: "استاد", value: "استاد" },
                                                                { label: "استادیار", value: "استادیار" },
                                                                { label: "دانشیار", value: "دانشیار" },
                                                                { label: "حق التدریس", value: "حق التدریس" },
                                                                { label: "مربی", value: "مربی" },
                                                            ]}
                                                            name={"type_of_employment_state"}
                                                            label={"مرتبه دانشگاهی"}
                                                            required
                                                        />
                                                    </Grid>
                                                </>
                                            }

                                        </Grid>

                                    </Box>
                                </>
                            )}

                            {FormStep === 2 && (
                                <>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 4,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                p: 2,
                                                backgroundColor: 'grey.main',
                                                borderRadius: '8px',
                                            }}
                                        >
                                            <Typography>انتخاب تاریخ اعزام</Typography>

                                        </Box>

                                        <Grid sx={{}} container spacing={3}>
                                            <Grid item xs={12} md={6}>
                                                <DispatchDateSelector.Element
                                                    name={"dispatch_date_1"}
                                                    label={"اولویت اول اعزام"}
                                                    required
                                                    travel_id={travelId}
                                                    province_name={getValues("provoince_university")?.label || undefined}
                                                    gender={(
                                                        (mirrageStatusWatcher?.value && mirrageStatusWatcher?.value === "متاهل") &&
                                                        tasharofWatcher?.value?.search("مجرد") === -1 &&
                                                        parseInt(hamrahCountWatcher?.value, 10) > 0 &&
                                                        hasHamragWatcher.value === "بله"
                                                    ) ? undefined : getValues("gender")?.value || undefined}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <DispatchDateSelector.Element
                                                    name={"dispatch_date_2"}
                                                    label={"اولویت دوم اعزام"}
                                                    travel_id={travelId}
                                                    province_name={getValues("provoince_university")?.label || undefined}
                                                    gender={(
                                                        (mirrageStatusWatcher?.value && mirrageStatusWatcher?.value === "متاهل") &&
                                                        tasharofWatcher?.value?.search("مجرد") === -1 &&
                                                        parseInt(hamrahCountWatcher?.value, 10) > 0 &&
                                                        hasHamragWatcher.value === "بله"
                                                    ) ? undefined : getValues("gender")?.value || undefined}
                                                    required
                                                />
                                            </Grid>
                                        </Grid>

                                    </Box>
                                </>
                            )}

                            {
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        gap: 2,
                                        mt: 5,
                                    }}
                                >
                                    {FormStep > 1 && (
                                        <LoadingButton loading={isLoading} variant="outlined" color={'success'} onClick={handleGoToPrevStep}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    gap: 2,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <ArrowForward />
                                                <Typography>
                                                    مرحله قبل
                                                </Typography>
                                            </Box>
                                        </LoadingButton>
                                    )}
                                    {(hasAccess(access.create) || hasAccess(access.update)) && (
                                        <LoadingButton loading={isLoading} type="submit" variant="contained" color={'success'}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    gap: 2,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <Typography>
                                                    {isAttabat ?
                                                        <>
                                                            {FormStep === 1 ? "مرحله بعدی" : (beforeRegistrant ? 'ویرایش اطلاعات' : 'ثبت اطلاعات')}
                                                        </>
                                                        :
                                                        <>
                                                            {beforeRegistrant ? 'ویرایش اطلاعات' : 'ثبت اطلاعات'}
                                                        </>
                                                    }
                                                </Typography>
                                                <ControlPoint />
                                            </Box>
                                        </LoadingButton>
                                    )}
                                </Box>
                            }
                            {isError ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        width: '100%',
                                        justifyContent: 'center',
                                        mt: 1,
                                    }}
                                >
                                    <FormHelperText error>{`لطفا تمام فیلد ها را با دقت پر نمایید`}</FormHelperText>
                                </Box>
                            ) : (
                                ''
                            )}
                        </FormProvider>
                    </Page>
                </>
            }
        </>
    );
}

export default FirstRegistryForm;